import React, { useContext, useState , useEffect} from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown, Tab, Tabs, } from "react-bootstrap";
import Swal from 'sweetalert2';
import cuotaspagadas from "../../assets/data/cuotaspagadas.json";
import { ButtonComponent } from "../elements";

import khipuLogo from "../../assets/images/khipu.png";
import webpayLogo from "../../assets/images/webpay.png";
import getnetLogo from "../../assets/images/Logo_WebCheckout_Getnet.svg";
import {getGira, cuotasAlumno, registrarPagosWebpay, registrarPagosKhipu, registrarPagosGetnet} from "../../api/giras.ts";
import { descargarArchivo} from "../../api/mantenedores.ts"; 
import paymentMethods from '../../config/paymentMethods';

export default function MisPagosGiraComponent({cuotas, gira, docsGira}) {

    const { t } = useContext(TranslatorContext)
    const [selectedCuotas, setSelectedCuotas] = useState([]);
    const [totalMonto, setTotalMonto] = useState(0);
    const [cuotasAlumno, setCuotasAlumno] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // Estado para el método de pago seleccionado
    const [multasModificadas, setMultasModificadas] = useState({});
    const [documentosGira, setDocumentosGira] = useState([]);

    // Métodos de pago habilitados
    const enabledMethods = Object.entries(paymentMethods)
      .filter(([_, enabled]) => enabled)
      .map(([method]) => method);

    useEffect(() => {
      
      
       const sumaTotalCuotas = cuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
       
    const totalCuotasPagadas = cuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
      
      const nuevasMultas = {};
      for (let i = 0; i < cuotas.length; i++) {
        const cuota = cuotas[i];
        if(i > 0){
          
          nuevasMultas[cuota.cuo_id] =cuota.multa;
        }else{
           nuevasMultas[cuota.cuo_id] = 0;
        }  
        
      }
      setMultasModificadas(nuevasMultas);
      setCuotasAlumno(cuotas) 
     
      setDocumentosGira(docsGira);

    }, [cuotas, docsGira]);

  
    


    const handleCheckboxChange = (cuota) => {
         const isSelected = selectedCuotas.includes(cuota.cuo_id);
    let newSelectedCuotas;
    let newTotalMonto;
    let multa  = 0;
    multa = multasModificadas[cuota.cuo_id];

    // Obtener las cuotas pendientes (no pagadas)
    const cuotasPendientes = cuotasAlumno.filter((c) => !c.cou_fpago);

    // Ordenar las cuotas pendientes por el número de cuota (o el campo que corresponda)
    // Si ya están ordenadas en el array, puedes omitir este paso

    // Encontrar el índice de la cuota actual en las cuotas pendientes
    const indexCuota = cuotasPendientes.findIndex(c => c.cuo_id === cuota.cuo_id);

    // Si se está seleccionando (no deseleccionando)
    if (!isSelected) {
        // Solo se puede seleccionar si todas las anteriores ya están seleccionadas
        const cuotasPrevias = cuotasPendientes.slice(0, indexCuota);
        const todasPreviasSeleccionadas = cuotasPrevias.every(c => selectedCuotas.includes(c.cuo_id));
        if (!todasPreviasSeleccionadas) {
            setTimeout(() => {
                const checkbox = document.querySelector(`input[data-cuo_id="${cuota.cuo_id}"]`);
                if (checkbox) checkbox.checked = false;
            }, 0);

            Swal.fire({
                icon: "warning",
                text: "Debe seleccionar las cuotas en orden.",
            });
            return;
        }
    } else {
        // Si se está deseleccionando, también deselecciona todas las posteriores
        const cuotasPosteriores = cuotasPendientes.slice(indexCuota + 1);
        newSelectedCuotas = selectedCuotas.filter(
            cuo_id => cuo_id !== cuota.cuo_id && !cuotasPosteriores.some(c => c.cuo_id === cuo_id)
        );
        // Recalcula el total
        let recalculoTotal = 0;
        newSelectedCuotas.forEach(cuo_id => {
            const c = cuotasAlumno.find(cu => cu.cuo_id === cuo_id);
            recalculoTotal += Number(c.cou_valor + (multasModificadas[cuo_id] || 0));
        });
        setSelectedCuotas(newSelectedCuotas);
        setTotalMonto(recalculoTotal);
        return;
    }

    // Selección normal
    newSelectedCuotas = [...selectedCuotas, cuota.cuo_id];
    newTotalMonto = totalMonto + Number(cuota.cou_valor + multa);

    setSelectedCuotas(newSelectedCuotas);
    setTotalMonto(newTotalMonto);
    };

    const handlePaymentMethodSelect = (method) => {
      console.log("Método de pago seleccionado:", method);
        setSelectedPaymentMethod(method); // Actualizar el método de pago seleccionado
      };

    const handlePay = async () => {
        // Validar que se hayan seleccionado cuotas
        if (!selectedCuotas || selectedCuotas.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Cuotas requeridas",
                text: "Por favor, seleccione al menos una cuota para pagar.",
                confirmButtonText: "Aceptar"
            });
            return;
        }

        // Validar que se haya seleccionado un método de pago
        if (!selectedPaymentMethod) {
            Swal.fire({
                icon: "warning",
                title: "Método de pago requerido",
                text: "Por favor, seleccione un método de pago antes de continuar.",
                confirmButtonText: "Aceptar"
            });
            return;
        }

        // Lógica para procesar el pago
        
        Swal.fire({
                   title: "Procesando...",
                   text: "Por favor, espere...",
                   allowOutsideClick: false,
                   didOpen: () => {
                     Swal.showLoading();
                   }
                 });

        if(selectedPaymentMethod === "Khipu") {
          registrarPagosKhipu(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            const form = document.createElement("form");
            form.action = response.url;
            form.method = "GET";

            
            document.body.appendChild(form);

            form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            const form = document.createElement("form");
            form.action = response.url;
            form.method = "GET";

            
            document.body.appendChild(form);

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        } else if(selectedPaymentMethod === "Webpay"){
          registrarPagosWebpay(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            const form = document.createElement("form");
            form.action = response.url;
            form.method = "POST";

            const inputToken = document.createElement("input");
            inputToken.type = "hidden";
            inputToken.name = "token_ws";
            inputToken.value = response.token;

            form.appendChild(inputToken);
            document.body.appendChild(form);

            form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        } else if(selectedPaymentMethod === "Getnet"){
          registrarPagosGetnet(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
              console.log("Redireccionando a:", response);
            const form = document.createElement("form");
            form.action = response.url;
            form.method = "GET";

            
            document.body.appendChild(form);
             form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        }       
         
    };

     const calculateMulta = (fechaVencimiento, valorGira, proximaFechaVencimiento = null) => {
    // fechaVencimiento y proximaFechaVencimiento en formato 'dd-mm-yyyy'
    const [day, month, year] = fechaVencimiento.split('-').map(Number);
    const fechaVenc = new Date(year, month - 1, day);

    // Sumar un día para que la multa empiece al día siguiente
    fechaVenc.setDate(fechaVenc.getDate() + 1);
    const fechaActual = new Date(); // fecha actual
    if(fechaActual <= fechaVenc ){
        return 0; // Si la fecha actual es antes o igual a la fecha de vencimiento, no hay multa
    }

    // Determinar hasta cuándo calcular la multa
    let fechaLimite;
    if (proximaFechaVencimiento) {
        const [nextDay, nextMonth, nextYear] = proximaFechaVencimiento.split('-').map(Number);
        fechaLimite = new Date(nextYear, nextMonth - 1, nextDay);
        if(fechaLimite >= fechaActual){
            fechaLimite = new Date(); // Si la próxima cuota es antes o igual a la fecha de vencimiento, no hay multa
        }
    } else {
        fechaLimite = new Date(); // fecha actual si no hay próxima cuota
    }

    // Si la fecha límite es menor o igual a la fecha de inicio de multa, no hay multa
    if (fechaLimite <= fechaVenc) {
        return 0;
    }
   
    if(gira.gir_mulmensual?.data[0]){
        return  Math.floor(valorGira * (gira.gir_porcmulta / 100) ); // 1% por semana
    }else{
         // Calcular semanas completas de atraso
        const diferenciaEnMilisegundos = fechaLimite - fechaVenc;
        const semanasAtraso = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 7));
         if(semanasAtraso === 0){
            return  Math.floor((1)  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
        }
        return  Math.floor(semanasAtraso * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
    }
   
    };

    const handleDownload = async (fileId, fileName) => {
                      try {
                        const response = await descargarArchivo(fileId, 'pdf');
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName); // Nombre del archivo
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                      } catch (error) {
                        Swal.fire({
                          icon: 'error',
                          text: 'Error al descargar el archivo'
                        });
                      }
              };

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">Pagos</h4>
               
            </div>
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                <Tab eventKey="profile" title="Cuotas Viajes" className="mc-tabpane profile">
                <ul className="mc-activity-card-list thin-scrolling">
               
                <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                        <th ></th>   
                         <th >Nº Cuota</th>
                         <th >Fecha vencimiento</th>
                         <th >Monto</th>
                         <th >Multa</th>
                         <th >A Pagar</th>
                         <th >Fecha de pago</th>
                         <th >Monto pagado</th>
                         <th >Detalle</th>
                        
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {cuotasAlumno.map((cuota, index) => {
                                                
                                                return (
                                                <tr key={cuota.cuo_id}>
                                                    <td>
                                                    {!cuota.cou_fpago && <input type="checkbox"  checked={selectedCuotas.includes(cuota.cuo_id)}  data-cuo_id={cuota.cuo_id} onChange={() => handleCheckboxChange(cuota)} />}
                                                    </td>
                                                    <td title="id">{cuota.cou_ncuota}</td>
                                                    <td title={cuota.cou_festpago}>{cuota.cou_festpago}</td>
                                                    <td title={cuota.cou_valor}>{cuota.cou_valor.toLocaleString('es-CL')}</td>
                                                    <td title="multa">
                                                      {!cuota.cou_fpago ?
                                                       (( multasModificadas[cuota.cuo_id] ).toLocaleString('es-CL') ) :
                                                       (cuota.cou_multa ? cuota.cou_multa.toLocaleString('es-CL') : 0)}
                                                       
                                                      </td> {/* Mostrar la multa calculada */}
                                                    <td title="apagar">  
                                                        {cuota.cou_fpago ?
                                                          ( Math.floor(cuota.cou_valor + (cuota.cou_multa || 0)).toLocaleString('es-CL') ): Math.floor(cuota.cou_valor + multasModificadas[cuota.cuo_id] ).toLocaleString('es-CL')} </td> {/* Sumar la multa al valor de la cuota */}
                                                    <td title={cuota.cou_fpago}>{cuota.cou_fpago}</td>
                                                    <td title={cuota.cou_montopagado}>{cuota.cou_montopagado?.toLocaleString('es-CL')}</td>
                                                    <td title={cuota.cou_detalle}>
                                                    {cuota.cou_detalle}
                                                    {cuota.web_id !== null && <p>Pago con Webpay</p>}
                                                    {cuota.khi_id !== null && <p>Pago con Khipu</p>}
                                                   {enabledMethods.includes('getnet') && (cuota.get_id !== null && <p>Pago con Getnet</p>)}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                    <div className="total-monto">
                        <h5>Total a Pagar: {totalMonto?.toLocaleString('es-CL')}</h5>
                    </div>
                    <div className="payment-methods">
                      <h5>Seleccione Método de Pago</h5>
                      <ul className="payment-methods-list" style={{ display: 'flex', justifyContent: 'space-around' }}>
                        {enabledMethods.includes('webpay') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Webpay")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Webpay" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={webpayLogo}
                              alt="Webpay"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "60px" }}
                            />
                            <p>Para pago con Tarjeta de crédito o <br/> débito, selecciona Webpay</p>
                          </li>
                        )}
                        {enabledMethods.includes('getnet') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Getnet")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Getnet" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={getnetLogo}
                              alt="Getnet"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "50px" }}
                            />
                            <p>Para pago con Tarjeta de crédito o <br/> débito, selecciona Getnet</p>
                          </li>
                        )}
                        {enabledMethods.includes('khipu') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Khipu")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Khipu" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={khipuLogo}
                              alt="Khipu"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "50px" }}
                            />
                            <p>Para pago con Khipu</p>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <ButtonComponent onClick={handlePay} className="btn btn-primary" >Pagar</ButtonComponent>
                    </div>
                </Tab>
                <Tab eventKey="password" title="Documentos" className="mc-tabpane password">
                <ul className="mc-activity-card-list thin-scrolling">
              
                     <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                        <th >Nombre Archivo</th>
                        <th >Descargar</th>
                        
                        
                        
                        
                       
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {documentosGira?.map((item, index) => (
                            <tr key={ index }>  

                                <td title="id">
                                { item.doc_nombre }
                                </td>   
                                <td title="id">
                                 <button type='button' className='mc-dropdown-menu' onClick={() => handleDownload(item.fil_id,  item.doc_nombre)}><i className='material-icons'>download</i><span>Descargar</span></button>
                                </td>  
                            </tr>
                            
                        ))}    

                    </tbody>
                    </table>
    
                
                    </ul>
                </Tab>    
            </Tabs>    
           
        </div>
    )
}